import React from "react";
import LazyImage from "../components/common/LazyImage";

const TestimonialCard = ({ testimonial }) => {
  return (
    <div className="bg-white p-6 h-75 sm:h-64 border-t-4 border-red-500">
      <div className="flex items-center gap-4 mb-4">
        <LazyImage
          src={testimonial.image}
          alt={testimonial.name}
          className="w-16 h-16 rounded-full border-4 border-red-200"
        />
        <div>
          <h3 className="font-semibold text-gray-800">{testimonial.name}</h3>
          <p className="text-red-600 text-sm">{testimonial.role}</p>
        </div>
      </div>
      <p className="text-gray-600 text-sm italic leading-relaxed mb-4">
        "{testimonial.feedback}"
      </p>
      <div className="flex items-center gap-1">
        {[...Array(5)].map((_, i) => (
          <svg
            key={i}
            className={`w-4 h-4 ${
              i < testimonial.rating ? "text-red-500" : "text-gray-300"
            }`}
            fill="currentColor"
            viewBox="0 0 20 20"
          >
            <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
          </svg>
        ))}
      </div>
    </div>
  );
};

export default TestimonialCard;
